import React from 'react';
import LegendItem, { LegendItemScheme } from './LegendItem';
// @ts-ignore
import styles from './Legend.module.scss';

interface Props {
	items: LegendItemScheme[];
}

const Legend: React.FC<Props> = ({ items }) => {
	return (
		<div className={styles.wrapper}>
			{items.map((item, key) => (
				<LegendItem item={item} key={key} />
			))}
		</div>
	);
};

export default Legend;
